var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/components/footer.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_2 = "";t_2 += "\r\n    <footer class=\"footer\">\r\n        <div class=\"container pt-20\">\r\n            <div class=\"row\">\r\n                <div class=\"columns\">\r\n                    <nav aria-label=\"Footer Navigation\">\r\n                        <ul class=\"footer__links\">\r\n                            <li class=\"footer__links-item\">\r\n                                <a href=\"https://www.indivior.com/en/data-policy\" itemprop=\"url\" class=\"footer__link\" target=\"_blank\" aria-label=>Privacy Policy</a>\r\n                            </li>\r\n                            <li class=\"footer__links-item\"> \r\n                                <a href=\"https://www.indivior.com/en/terms-of-use\" class=\"footer__link\" target=\"_blank\">Terms of Use</a>\r\n                            </li>\r\n                             <li class=\"footer__links-item\"> \r\n                                <a href=\"https://www.indivior.com/en/accessibility\" class=\"footer__link\" target=\"_blank\">Accessibility</a>\r\n                            </li>\r\n                            <li class=\"footer__links-item\">\r\n                                <a href=\"https://www.indivior.com/en/contact-us\" class=\"footer__link\" target=\"_blank\">Contact Us</a>\r\n                            </li>\r\n                            <li class=\"footer__links-item\">\r\n                                <!-- OptanonCookieSettingsButtonStart -->\r\n                                <button id=\"ot-sdk-btn\" class=\"ot-sdk-show-settings footer__link\">Do Not Sell or Share My Personal Information</button>\r\n                                <!-- OptanonCookieSettingsButtonEnd -->\r\n                            </li>\r\n                        </ul>\r\n                    </nav>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"nine columns\">\r\n                    <p class=\"footer__paragraph mt-20\">&copy; 2025 Indivior UK Limited | SUBLOCADE&reg;, INDIVIOR&reg;, and INSUPPORT&reg; are registered trademarks of Indivior UK Limited or its affiliate companies. | All rights reserved.</p>\r\n                    <p class=\"footer__paragraph mt-10\">Intended Only for US Audiences.</p>\r\n                    <p class=\"footer__paragraph mt-10\">NP-BAG-US-00901v2 Apr 2025</p>\r\n                </div>\r\n                <div class=\"three columns\">\r\n                    <a href=\"https://www.indivior.com/en\" target=\"_blank\" rel=\"noreferrer\">\r\n                        <img class=\"footer-logo mt-20\" src=\"/assets/img/shared/indivior_logo@2x.png\" alt=\"[Indivior] logo\">\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </footer>\r\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/components/footer.njk"] , dependencies)